import { defineActions } from '@noven-prime/lattice-core';
import { getMediaStore } from './store.js';
/**
 * Media Library capability actions
 */
export const mediaLibraryActions = defineActions({
    /**
     * List all media blobs.
     */
    listMedia: {
        id: 'listMedia',
        name: 'List Media',
        description: 'List the images and files in the media library',
        params: { type: 'object', properties: {} },
        result: { type: 'array', items: { type: 'object' } },
        access: {
            scopes: ['root', 'admin'],
        },
        execute: async (_params, _context) => {
            return getMediaStore().list();
        },
    },
    /**
     * Upload a media file (base64 payload).
     */
    uploadMedia: {
        id: 'uploadMedia',
        name: 'Upload Media',
        description: 'Upload an image or file to the media library',
        params: {
            type: 'object',
            properties: {
                name: { type: 'string', description: 'Blob name, e.g. hero-photo.jpg' },
                contentType: { type: 'string', description: 'MIME type of the file' },
                dataBase64: { type: 'string', description: 'File contents, base64 encoded' },
            },
            required: ['name', 'contentType', 'dataBase64'],
        },
        result: { type: 'object' },
        access: {
            scopes: ['root', 'admin'],
        },
        execute: async (params, _context) => {
            return getMediaStore().upload(params.name, params.contentType, params.dataBase64);
        },
    },
    /**
     * Delete a media file.
     */
    deleteMedia: {
        id: 'deleteMedia',
        name: 'Delete Media',
        description: 'Remove a file from the media library',
        params: {
            type: 'object',
            properties: {
                name: { type: 'string', description: 'Blob name to delete' },
            },
            required: ['name'],
        },
        result: { type: 'object' },
        access: {
            scopes: ['root', 'admin'],
        },
        execute: async (params, _context) => {
            await getMediaStore().remove(params.name);
            return { deleted: true };
        },
    },
});
//# sourceMappingURL=actions.js.map